import React from "react";
import { Box, Skeleton, Stack, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";

/**
 * Skeleton loader for the User Management table. Mirrors the loaded
 * table layout (serial, avatar + name/email, location, totals, status chips, action)
 * so the loading state has the same shape as the loaded page.
 */
export default function AdminUsersSkeleton() {
  return (
    <Table>
      <TableHead sx={{ bgcolor: (theme) => theme.palette.table.headBg }}>
        <TableRow>
          {[
            "Serial No.",
            "User",
            "Location",
            "Total Invested",
            "Assets",
            "KYC Status",
            "Status",
            "Actions",
          ].map((h) => (
            <TableCell key={h} sx={{ py: 1.5 }}>
              <Skeleton variant="text" width={80} height={18} />
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {[0, 1, 2, 3, 4].map((i) => (
          <TableRow key={i}>
            <TableCell>
              <Skeleton variant="text" width={36} height={18} />
            </TableCell>
            <TableCell>
              <Stack direction="row" alignItems="center" spacing={1.5}>
                <Skeleton variant="circular" width={36} height={36} />
                <Box>
                  <Skeleton variant="text" width={140} height={18} />
                  <Skeleton variant="text" width={180} height={14} />
                </Box>
              </Stack>
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width={120} height={18} />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width={90} height={18} />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width={50} height={18} />
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={70} height={24} sx={{ borderRadius: 999 }} />
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={70} height={24} sx={{ borderRadius: 999 }} />
            </TableCell>
            <TableCell>
              <Skeleton variant="circular" width={28} height={28} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
